import React, { FC } from 'react'
import { Icon } from '@iconify/react'
import S from './Spinner.styles'

interface SpinnerProps {
  size?: number
  color?: string
}

const Spinner: FC<SpinnerProps> = ({ size = 20, color = 'currentColor' }) => {
  return (
    <S.Spinner>
      <Icon icon="mdi:loading" fontSize={size} color={color} />
    </S.Spinner>
  )
}

export default Spinner
